import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ApiRequestService, DialogComponent, DialogConfiguration, DialogService, ToastmessageService } from '@prekog/common-ui';
import { Doctor } from '../doctor';
import { DeleteConsultingHourRequest } from '../models/deleteconsultinghourrequest';
import { DoctorConsultingHour } from '../updatedoctor/doctorconsultinghour';
import { FIndConsultingHoursRequest } from '../updatedoctor/findConsultingHoursRequest';
import { FindConsultingHoursResponse } from '../updatedoctor/findConsultingHoursResponse';
import { FindDoctorRequest } from '../updatedoctor/finddoctorrequest';
import { FindDoctorResponse } from '../updatedoctor/finddoctorresponse';
import { AddConsultingHourRequest } from './addconsultinghourrequest';

@Component({
    selector: 'app-addconsultationhour',
    templateUrl: './addconsultationhour.component.html',
    styleUrls: ['./addconsultationhour.component.scss'],
    standalone: true,
    imports: [MatIconModule, RouterModule, FormsModule, CommonModule, ReactiveFormsModule, MatTimepickerModule, FormsModule]
})
export class AddconsultationhourComponent implements OnInit {
    addConsultingHourUrl = '/admin/add-consulting-hour';

    consultationHourForm?: FormGroup;

    deleteConsultingHourUrl = '/admin/delete-consulting-hour';

    doctor: Doctor = {};

    doctorConsultingHour: DoctorConsultingHour = {};

    doctorConsultingHoursList?: DoctorConsultingHour[];

    findAllConsultingHoursUrl = '/regenero/find-consulting-hour';

    findDoctorUrl = '/regenero/find-doctor-by-routerlink';

    originalRouterLink = '';
    regeneroBaseUrl = '';
    private _route = inject(ActivatedRoute);
    private _dialogService = inject(DialogService);

    constructor(
        public _router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
        private _toastMessageService: ToastmessageService,
        private _fb: FormBuilder
    ) {
        this.regeneroBaseUrl = _regeneroBaseUrl;
        this.createConsultationHourForm();
    }

    ngOnInit(): void {
        this.findDoctor();
    }

    findDoctor(): void {
        this.originalRouterLink = this._route.snapshot.paramMap.get('routerLink') as string;
        const findDoctorRequest: FindDoctorRequest = {
            routerLink: this.originalRouterLink
        };

        this._apiRequestService
            .sendRequest<FindDoctorRequest, FindDoctorResponse>(this.regeneroBaseUrl, findDoctorRequest, true, this.findDoctorUrl)
            .subscribe((response) => {
                this.doctor = response.doctor!;
                this.getConsultingHours();
            });
    }

    createConsultationHourForm(): void {
        this.consultationHourForm = this._fb.group({
            day: ['', [Validators.required]],
            startTime: ['', [Validators.required]],
            endTime: ['', [Validators.required]]
        });
    }

    collectConsultationHourData(): void {
        this.doctorConsultingHour = {
            day: this.consultationHourForm?.controls['day'].value as string | undefined,
            startTime: this.consultationHourForm?.controls['startTime'].value as string | undefined,
            endTime: this.consultationHourForm?.controls['endTime'].value as string | undefined,
            doctorId: this.doctor.id
        };
    }

    openDeleteConsultingDialog(id: number): void {
        const dialogConfiguration: DialogConfiguration = {
            messageKey: 'consultingHour.deleteConfirmMessage'
        };

        this._dialogService.openDialog(
            DialogComponent,
            dialogConfiguration,
            () => this._deleteConsultingHour(id)
        );
    }

    private _deleteConsultingHour(id: number): void {
        const deleteConsultingHourRequest: DeleteConsultingHourRequest = {
            id: id
        };

        this._apiRequestService
            .sendRequest<
                DeleteConsultingHourRequest,
                HttpResponse<any>
            >(this.regeneroBaseUrl, deleteConsultingHourRequest, true, this.deleteConsultingHourUrl, true)
            .subscribe(() => {
                this.doctorConsultingHoursList = this.doctorConsultingHoursList?.filter(
                    (existingConsultingHour) => existingConsultingHour.id !== id
                );
            });
    }

    getConsultingHours(): void {
        const findConsultingHoursRequest: FIndConsultingHoursRequest = {
            doctorId: this.doctor.id
        };

        this._apiRequestService
            .sendRequest<
                FIndConsultingHoursRequest,
                FindConsultingHoursResponse
            >(this.regeneroBaseUrl, findConsultingHoursRequest, true, this.findAllConsultingHoursUrl)
            .subscribe((response) => {
                this.doctorConsultingHoursList = response.doctorConsultingHourList!;
            });
    }

    addConsultationHour(): void {
        this.collectConsultationHourData();

        const addConsultingHourRequest: AddConsultingHourRequest = {
            doctorConsultingHour: this.doctorConsultingHour
        };

        this._apiRequestService
            .sendRequest<
                AddConsultingHourRequest,
                HttpResponse<any>
            >(this.regeneroBaseUrl, addConsultingHourRequest, true, this.addConsultingHourUrl, true)
            .subscribe(() => {
                this._router.navigateByUrl('/doctor/' + this.originalRouterLink);
            });
    }
}
